import { generatePath, useHistory } from "react-router-dom";
import { FragmentFields } from "@scrile/api-provider/dist/api/types";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { useFindByUserName } from "hooks/useFindByUserName";
import { useHideFooter } from "hooks/useHideFooter";
import { Routes } from "../../router/config";

const searchFields: FragmentFields<UserPublicData> = [
  "id",
  "role",
  "username",
  "screenName",
  "disabled",
  { onlineStatus: ["isOnline"] },
  { publicLivechatUser: ["broadcasting"] },
  { avatar: ["urlPart"] },
];

export default function useController(username: string) {
  const history = useHistory();
  useHideFooter();
  const { user } = useFindByUserName(username, searchFields, () => {
    history.push(Routes.root);
  });

  const onClose = () => {
    history.replace(generatePath(Routes.rootByUsername, { username }));
  };

  return {
    user,
    onClose,
  };
}
